import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import i18n from "../../i18n/i18n";
const BASE_URL = process.env.REACT_APP_BASE_URL;

// all employee document
export const fetchEmployeeDocument = createAsyncThunk(
  "employee_document/fetchAll",
  async ({ page = 1, document_number = "", status = "" ,
    is_auto_renewal = "",
    has_expire_date = "" }, { rejectWithValue }) => {
    try {
      const normalize = (val) => {
        if (val === "true" || val === true) return 1;
        if (val === "false" || val === false) return 0;
        return "";
      };
      const response = await axios.get(`${BASE_URL}/employee-documents?page=${page}&document_number=${document_number}&status=${status}&is_auto_renewal=${normalize(is_auto_renewal)}&has_expire_date=${normalize(has_expire_date)}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
          Lang: i18n.language,
        },
      });
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || "Failed load data";
      return rejectWithValue(message);
    }
  }
);

// add employee documents
export const addEmployeeDocument = createAsyncThunk(
  "employee_document/add",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${BASE_URL}/employee-documents`, userData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "multipart/form-data",
          Lang: i18n.language,
        },
      });
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "An unknown error occurred";
      return rejectWithValue(message);
    }
  }
);
// add employee documents comments
export const addEmployeeDocumentComments = createAsyncThunk(
  "employee_document/comments",
  async ({ comment, id }, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${BASE_URL}/employee-documents/${id}/comments`, comment, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
          Lang: i18n.language,
        },
      });
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "An unknown error occurred";
      return rejectWithValue(message);
    }
  }
);
// get employee documents record
export const employeeDocumentRecord = createAsyncThunk(
  "employee_document/employeeDocumentRecord",
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/employee-documents/${id}`);
      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.message || "An unknown error occurred";
      return rejectWithValue({ message });
    }
  }
);
// Fetch all employee documents once (for filters)
export const fetchAllEmployeeDocument = createAsyncThunk(
  "employee_document/fetchAllFull",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/employee-documents`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
          Lang: i18n.language,
        },
      });
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || "Failed to load all data";
      return rejectWithValue(message);
    }
  }
);
const EmployeeDocumentSlice = createSlice({
  name: "employee_document",
  initialState: {
    employee_document: [],
    all_employee_document: [],
    record: null,
    isLoading: false,
    error: null,
    success: null,
    successComment: null,
    errorComment: null,
    successDelete: null,
    errorDelete: null,
    pagination: null,
  },
  reducers: {
    clearState: (state) => {
      state.error = null;
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchEmployeeDocument.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchEmployeeDocument.fulfilled, (state, action) => {
        state.isLoading = false;
        state.employee_document = action.payload.data.data;
        state.pagination = action.payload.data.pagination;
      })
      .addCase(fetchEmployeeDocument.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to load data";
      })
      .addCase(fetchAllEmployeeDocument.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchAllEmployeeDocument.fulfilled, (state, action) => {
        state.isLoading = false;
        state.all_employee_document = action.payload.data.data;
      })
      .addCase(fetchAllEmployeeDocument.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to load all employee documents";
      })
      .addCase(addEmployeeDocument.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(addEmployeeDocument.fulfilled, (state, action) => {
        state.isLoading = false;
        state.success = action.payload.message;
      })
      .addCase(addEmployeeDocument.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to add data";
      })
      .addCase(addEmployeeDocumentComments.pending, (state) => {
        state.isLoading = true;
        state.errorComment = null;
      })
      .addCase(addEmployeeDocumentComments.fulfilled, (state, action) => {
        state.isLoading = false;
        state.successComment = action.payload.message;
      })
      .addCase(addEmployeeDocumentComments.rejected, (state, action) => {
        state.isLoading = false;
        state.errorComment = action.payload || "Failed to add data";
      })
      .addCase(employeeDocumentRecord.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(employeeDocumentRecord.fulfilled, (state, action) => {
        state.isLoading = false;
        state.record = action.payload.data;
      })
      .addCase(employeeDocumentRecord.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error?.message || "Failed to add data";
      });
  },
});

export const { clearState } = EmployeeDocumentSlice.actions;
export default EmployeeDocumentSlice.reducer;